module.exports = __webpack_public_path__ + "static/selected-language-screen@2x-058c02661ba00d7c660f09fd37b2a2d7.png";